export default {
    active: {
        chipColor: '#39CF86',
        label: window.i18n.__('Actif'),
    },
    closed: {
        chipColor: '#565665',
        label: window.i18n.__('Fermé'),
    },
    pending: {
        chipColor: '#8C909C',
        label: window.i18n.__('En attente'),
    },
    spam: {
        chipColor: '#F06868',
        label: window.i18n.__('Spam'),
    },
};
